import '@fontsource/noto-sans-jp/latin-200.css';
import '@fontsource/noto-sans-jp/latin-400.css';
import { cn } from '@/components/ui';
import { BLOOM_SLOW } from './schedule';
import './wordmark.css';

/*
  KanameWordmark — слово «KANAME» с коралловой точкой-ядром (docs/brand-concept.md). Гарнитура —
  Noto Sans JP: прописные с разрядкой, японская строгость. Два размера: крупно и тонко на сцене
  входа; в строке — рядом со знаком (главное меню, шапка формы входа).

  На сцене шесть букв — шесть лепестков: каждая буква проявляется из прозрачного вместе со своим
  лепестком, по тому же расписанию; точка-ядро выскакивает с лёгкой пружиной вскоре после последней
  буквы, не дожидаясь, пока последний лепесток окончательно сядет.
*/

interface KanameWordmarkProps {
  /** stage — крупно на сцене входа; inline — в строке рядом со знаком, цвет от родителя. */
  size?: 'stage' | 'inline';
  /** hidden — ждём раскрытия; play — проявляться по расписанию веера; still — сразу видно. */
  play?: 'hidden' | 'play' | 'still';
  className?: string;
}

const LETTERS = ['K', 'A', 'N', 'A', 'M', 'E'];
/** Буква выходит чуть позже старта своего лепестка. */
const LETTER_LAG_MS = 150;
/** Когда на сцене выскакивает точка: через 0,6 с после последней буквы (от начала раскрытия). */
export const WORDMARK_DOT_MS = BLOOM_SLOW.delays[LETTERS.length - 1] + LETTER_LAG_MS + 600;

export function KanameWordmark({ size = 'inline', play = 'still', className }: KanameWordmarkProps) {
  const animate = play === 'play';
  return (
    <span
      data-wordmark={size}
      role="img"
      aria-label="Kaname"
      className={cn(play === 'hidden' && 'invisible', className)}
    >
      {LETTERS.map((ch, i) => (
        <span
          key={i}
          aria-hidden
          data-letter-in={animate || undefined}
          // Буква выходит вместе со своим лепестком: чуть позже его старта.
          style={animate ? { animationDelay: `${BLOOM_SLOW.delays[i] + LETTER_LAG_MS}ms` } : undefined}
        >
          {ch}
        </span>
      ))}
      <span
        aria-hidden
        data-wordmark-dot=""
        data-dot-in={animate || undefined}
        style={animate ? { animationDelay: `${WORDMARK_DOT_MS}ms` } : undefined}
      />
    </span>
  );
}
